import { Swatch } from 'src/components/ProductDetail/ProductSwatch';
import { Size } from 'src/components/ProductDetail/ProductSizes';
import {
    BundleDataBundleOptionInterface,
    QuoteDataCartItemInterface,
    WorkwearExpressBundleDataBundledCustomisationInterface,
    WorkwearExpressBundleDataOptionSelectionQtyInterface,
} from 'swagger/ts/Definitions';
import { selectVariantFromOptions } from 'src/components/ProductDetail/utils/selectVariantsFromOptions';
import { BundleOptions } from 'src/components/BundleProduct/utils/bundleOptionsFromQuery';
import { BaseVariant } from 'src/components/ProductDetail/utils/product-detail.types';
import { CollatedDataMap } from 'src/components/WeareBundleProduct/hooks/useWearerBundleFormState';
import { bundleCustomisationProps } from 'src/components/BundleProduct/utils/formToCustomisation';
import Bugsnag from '@bugsnag/js';

/**
 *
 */
export const EMPTY_ARR: FormItem[] = [];
export const initialState: FormData = {
    items: EMPTY_ARR,
    totalQty: 0,
    disabled: true,
    parentSku: '',
    parentId: -1,
    artworksData: {},
};
export type FormData = {
    items: FormItem[];
    totalQty: number;
    disabled: boolean;
    parentSku: string;
    parentId: number;
    artworksData: bundleCustomisationProps;
};
export type FormItem = { swatch: Swatch; sizes: { size: Size; qty: number }[] };

/**
 * Create bundle options from form data
 * @param formData
 * @param bundleOptions
 * @param variants
 */
export function formToBundleOptions(
    formData: FormData,
    bundleOptions: BundleOptions,
    variants: BaseVariant[],
): BundleDataBundleOptionInterface[] {
    const { items } = formData;
    const option_selections: number[] = [];
    const option_selections_qty: WorkwearExpressBundleDataOptionSelectionQtyInterface[] = [];
    items.forEach((item) => {
        item.sizes.forEach((size) => {
            const selections = { color: item.swatch.value_index, size: size.size.id } as { [index: string]: any };
            const variant = selectVariantFromOptions(selections, variants!);
            if (variant) {
                const simpleSku = variant.sku;
                const match = bundleOptions.items[simpleSku];
                if (match) {
                    option_selections.push(match.optionItemID);
                    option_selections_qty.push({
                        selection_id: match.optionItemID,
                        selection_qty: size.qty,
                    });
                } else {
                    Bugsnag.notify(`no match found for sku ${variant.sku}`);
                }
            }
        });
    });
    return [
        {
            option_id: bundleOptions.optionId,
            option_qty: 1,
            option_selections,
            extension_attributes: {
                option_selections_qty,
            },
        },
    ];
}

export function createBundlePayload(
    sku: string,
    customisation: MaybeCustomisation[] | undefined,
    options: BundleDataBundleOptionInterface[],
): {
    quote_id: string;
    sku: string;
    qty: number;
    product_option: {
        extension_attributes: {
            bundled_customisation: any;
            bundle_options: any;
        };
    };
} {
    // Magento did not create properly types
    // ): QuoteDataCartItemInterface {
    return {
        quote_id: '-1',
        sku: sku,
        qty: 1,
        product_option: {
            extension_attributes: {
                bundled_customisation: customisation,
                bundle_options: options,
            },
        },
    };
}

export function formDataToQtyMap(formState: CollatedDataMap): Record<number, number> {
    const output: Record<number, number> = {};
    Object.keys(formState.items).forEach((productId) => {
        const curr = formState.items[productId].raw;
        let sum = 0;
        Object.keys(curr).forEach((key) => {
            if (key.indexOf('index') === 0) {
                Object.keys(curr[key]).forEach((sizeKey) => {
                    if (sizeKey.indexOf('size') === 0) {
                        const curr2 = curr[key][sizeKey];
                        sum += parseInt(curr2);
                    }
                });
            }
        });
        output[productId] = sum;
    });
    return output;
}

export type MaybeCustomisation = WorkwearExpressBundleDataBundledCustomisationInterface | undefined;
